import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MonumentMegalithic2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MONUMENT_MEGALITHIC2;
}

export default MonumentMegalithic2PoiTileEntity;
